<template>
    <BasicModalWindow
      class="small-window contacts-delete"
      :title="`contacts.delete.${delete_type}_${delete_amount}_title`"
      @modalWindowClose="onModalClose()"
    >
        <template #body>
            <p>
                {{Language.say(`contacts.delete.${delete_type}_${delete_amount}_confirm_pre`)}}
                <strong v-if="contacts_selection.count === 1"> {{contacts_selection.items[0].name}} </strong>
                <strong v-else>  {{contacts_selection.count}} </strong>{{Language.say(`contacts.delete.${delete_type}_${delete_amount}_confirm_pos`)}}
            </p>
            <p>
                {{Language.say('contacts.delete.non_reversable')}}
            </p>
        </template>

        <template #footer>
            <ActionButton
              @click="onModalClose()"
              text="global.actions.cancel"
            />
            <ActionButton
              @click="onDeleteConfirm()"
              class='danger push-right'
              text="global.actions.confirm"
              :loading="contacts_controller.state.events['delete'] === 'loading'"
            />
        </template>
    </BasicModalWindow>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';
  import {onBeforeMount, ref}       from 'vue';
  import BasicModalWindow           from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton               from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language                   from '@/js/Shared/Language/Language.js';
  import ContactsController         from '@/js/Contacts/ContactsController';

  const emit = defineEmits([
    'deleteSuccess', 'deleteCancel'
  ])

  const props   = defineProps({
    contacts_selection : {
      required: true,
    },
    broadcast_message: {
      type: String,
      default: 'contacts-deleted'
    }
  })


  const contacts_controller = ContactsController;
  const delete_type         = ref(null);
  const delete_amount       = ref(null);

  onBeforeMount(() => {
    setDeleteType();
    setDeleteAmount();
  })

  const onModalClose = () => {
    emit('deleteCancel');
  }

  const onDeleteConfirm = async () => {
    if (await contacts_controller.deleteContacts(props.contacts_selection.getIndexKeys(), props.broadcast_message) === false) {
      return;
    }

    emit('deleteSuccess');
  }

  const setDeleteType = () => {
    delete_type.value = (props.contacts_selection.groups_count === props.contacts_selection.count) ? 'groups' : 'contacts';
  }


  const setDeleteAmount = () => {
    delete_amount.value = (props.contacts_selection.count === 1) ? 'single' : 'multi';
  }
</script>
